package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings0 {
  internal val _1: StringResource by lazy { init__1() }

  internal val _10: StringResource by lazy { init__10() }

  internal val abcd_hebrew: StringResource by lazy { init_abcd_hebrew() }

  internal val about: StringResource by lazy { init_about() }

  internal val action_reorder: StringResource by lazy { init_action_reorder() }

  internal val ad_free_for_minutes_action: StringResource by lazy {
      init_ad_free_for_minutes_action() }

  internal val ad_label: StringResource by lazy { init_ad_label() }

  internal val ad_not_available: StringResource by lazy { init_ad_not_available() }

  internal val ad_place: StringResource by lazy { init_ad_place() }

  internal val add_bookmark: StringResource by lazy { init_add_bookmark() }

  internal val add_nikud: StringResource by lazy { init_add_nikud() }

  internal val add_open_question: StringResource by lazy { init_add_open_question() }

  internal val add_question: StringResource by lazy { init_add_question() }

  internal val add_questions_from_sheet: StringResource by lazy { init_add_questions_from_sheet() }

  internal val ads_already_disabled_format: StringResource by lazy {
      init_ads_already_disabled_format() }

  internal val advanced_options: StringResource by lazy { init_advanced_options() }

  internal val all_the_bible: StringResource by lazy { init_all_the_bible() }

  internal val alphabetical: StringResource by lazy { init_alphabetical() }

  internal val and_lasted: StringResource by lazy { init_and_lasted() }

  internal val announcement: StringResource by lazy { init_announcement() }

  internal val answer: StringResource by lazy { init_answer() }

  internal val answers_list: StringResource by lazy { init_answers_list() }

  internal val app_name: StringResource by lazy { init_app_name() }

  internal val app_name_debug: StringResource by lazy { init_app_name_debug() }

  internal val app_up_to_date: StringResource by lazy { init_app_up_to_date() }

  internal val app_up_to_date_version_format: StringResource by lazy {
      init_app_up_to_date_version_format() }

  internal val apply_mikud: StringResource by lazy { init_apply_mikud() }

  internal val at_least_one_book: StringResource by lazy { init_at_least_one_book() }

  internal val available_in_full_version: StringResource by lazy { init_available_in_full_version()
      }

  internal val back: StringResource by lazy { init_back() }

  internal val background: StringResource by lazy { init_background() }

  internal val bible: StringResource by lazy { init_bible() }

  internal val bible_contest_for: StringResource by lazy { init_bible_contest_for() }

  internal val bible_recordings: StringResource by lazy { init_bible_recordings() }

  internal val book_name: StringResource by lazy { init_book_name() }

  internal val bookmark_added: StringResource by lazy { init_bookmark_added() }

  internal val bookmark_not_added_yet: StringResource by lazy { init_bookmark_not_added_yet() }

  internal val books: StringResource by lazy { init_books() }

  internal val books_and_chapters: StringResource by lazy { init_books_and_chapters() }

  internal val browse: StringResource by lazy { init_browse() }

  internal val browse_and_complete_chapter: StringResource by lazy {
      init_browse_and_complete_chapter() }

  internal val browse_bible: StringResource by lazy { init_browse_bible() }

  internal val browse_chumash: StringResource by lazy { init_browse_chumash() }

  internal val browse_place: StringResource by lazy { init_browse_place() }

  internal val by_user_choice: StringResource by lazy { init_by_user_choice() }

  internal val cancel: StringResource by lazy { init_cancel() }

  internal val cannot_open_link: StringResource by lazy { init_cannot_open_link() }

  internal val chapter_complete_reset: StringResource by lazy { init_chapter_complete_reset() }

  internal val chapter_content_title: StringResource by lazy { init_chapter_content_title() }

  internal val chapter_copy: StringResource by lazy { init_chapter_copy() }

  internal fun values(): List<StringResource> = listOf(_1, _10, abcd_hebrew, about, action_reorder,
      ad_free_for_minutes_action, ad_label, ad_not_available, ad_place, add_bookmark, add_nikud,
      add_open_question, add_question, add_questions_from_sheet, ads_already_disabled_format,
      advanced_options, all_the_bible, alphabetical, and_lasted, announcement, answer, answers_list,
      app_name, app_name_debug, app_up_to_date, app_up_to_date_version_format, apply_mikud,
      at_least_one_book, available_in_full_version, back, background, bible, bible_contest_for,
      bible_recordings, book_name, bookmark_added, bookmark_not_added_yet, books,
      books_and_chapters, browse, browse_and_complete_chapter, browse_bible, browse_chumash,
      browse_place, by_user_choice, cancel, cannot_open_link, chapter_complete_reset,
      chapter_content_title, chapter_copy)
}

private fun init__1(): StringResource = StringResource(key = "_1", loader = stringsLoader)

private fun init__10(): StringResource = StringResource(key = "_10", loader = stringsLoader)

private fun init_abcd_hebrew(): StringResource = StringResource(key = "abcd_hebrew", loader =
    stringsLoader)

private fun init_about(): StringResource = StringResource(key = "about", loader = stringsLoader)

private fun init_action_reorder(): StringResource = StringResource(key = "action_reorder", loader =
    stringsLoader)

private fun init_ad_free_for_minutes_action(): StringResource = StringResource(key =
    "ad_free_for_minutes_action", loader = stringsLoader)

private fun init_ad_label(): StringResource = StringResource(key = "ad_label", loader =
    stringsLoader)

private fun init_ad_not_available(): StringResource = StringResource(key = "ad_not_available",
    loader = stringsLoader)

private fun init_ad_place(): StringResource = StringResource(key = "ad_place", loader =
    stringsLoader)

private fun init_add_bookmark(): StringResource = StringResource(key = "add_bookmark", loader =
    stringsLoader)

private fun init_add_nikud(): StringResource = StringResource(key = "add_nikud", loader =
    stringsLoader)

private fun init_add_open_question(): StringResource = StringResource(key = "add_open_question",
    loader = stringsLoader)

private fun init_add_question(): StringResource = StringResource(key = "add_question", loader =
    stringsLoader)

private fun init_add_questions_from_sheet(): StringResource = StringResource(key =
    "add_questions_from_sheet", loader = stringsLoader)

private fun init_ads_already_disabled_format(): StringResource = StringResource(key =
    "ads_already_disabled_format", loader = stringsLoader)

private fun init_advanced_options(): StringResource = StringResource(key = "advanced_options",
    loader = stringsLoader)

private fun init_all_the_bible(): StringResource = StringResource(key = "all_the_bible", loader =
    stringsLoader)

private fun init_alphabetical(): StringResource = StringResource(key = "alphabetical", loader =
    stringsLoader)

private fun init_and_lasted(): StringResource = StringResource(key = "and_lasted", loader =
    stringsLoader)

private fun init_announcement(): StringResource = StringResource(key = "announcement", loader =
    stringsLoader)

private fun init_answer(): StringResource = StringResource(key = "answer", loader = stringsLoader)

private fun init_answers_list(): StringResource = StringResource(key = "answers_list", loader =
    stringsLoader)

private fun init_app_name(): StringResource = StringResource(key = "app_name", loader =
    stringsLoader)

private fun init_app_name_debug(): StringResource = StringResource(key = "app_name_debug", loader =
    stringsLoader)

private fun init_app_up_to_date(): StringResource = StringResource(key = "app_up_to_date", loader =
    stringsLoader)

private fun init_app_up_to_date_version_format(): StringResource = StringResource(key =
    "app_up_to_date_version_format", loader = stringsLoader)

private fun init_apply_mikud(): StringResource = StringResource(key = "apply_mikud", loader =
    stringsLoader)

private fun init_at_least_one_book(): StringResource = StringResource(key = "at_least_one_book",
    loader = stringsLoader)

private fun init_available_in_full_version(): StringResource = StringResource(key =
    "available_in_full_version", loader = stringsLoader)

private fun init_back(): StringResource = StringResource(key = "back", loader = stringsLoader)

private fun init_background(): StringResource = StringResource(key = "background", loader =
    stringsLoader)

private fun init_bible(): StringResource = StringResource(key = "bible", loader = stringsLoader)

private fun init_bible_contest_for(): StringResource = StringResource(key = "bible_contest_for",
    loader = stringsLoader)

private fun init_bible_recordings(): StringResource = StringResource(key = "bible_recordings",
    loader = stringsLoader)

private fun init_book_name(): StringResource = StringResource(key = "book_name", loader =
    stringsLoader)

private fun init_bookmark_added(): StringResource = StringResource(key = "bookmark_added", loader =
    stringsLoader)

private fun init_bookmark_not_added_yet(): StringResource = StringResource(key =
    "bookmark_not_added_yet", loader = stringsLoader)

private fun init_books(): StringResource = StringResource(key = "books", loader = stringsLoader)

private fun init_books_and_chapters(): StringResource = StringResource(key = "books_and_chapters",
    loader = stringsLoader)

private fun init_browse(): StringResource = StringResource(key = "browse", loader = stringsLoader)

private fun init_browse_and_complete_chapter(): StringResource = StringResource(key =
    "browse_and_complete_chapter", loader = stringsLoader)

private fun init_browse_bible(): StringResource = StringResource(key = "browse_bible", loader =
    stringsLoader)

private fun init_browse_chumash(): StringResource = StringResource(key = "browse_chumash", loader =
    stringsLoader)

private fun init_browse_place(): StringResource = StringResource(key = "browse_place", loader =
    stringsLoader)

private fun init_by_user_choice(): StringResource = StringResource(key = "by_user_choice", loader =
    stringsLoader)

private fun init_cancel(): StringResource = StringResource(key = "cancel", loader = stringsLoader)

private fun init_cannot_open_link(): StringResource = StringResource(key = "cannot_open_link",
    loader = stringsLoader)

private fun init_chapter_complete_reset(): StringResource = StringResource(key =
    "chapter_complete_reset", loader = stringsLoader)

private fun init_chapter_content_title(): StringResource = StringResource(key =
    "chapter_content_title", loader = stringsLoader)

private fun init_chapter_copy(): StringResource = StringResource(key = "chapter_copy", loader =
    stringsLoader)

public actual val SharedRes.strings._1: StringResource
  get() = CommonMainStrings0._1

public actual val SharedRes.strings._10: StringResource
  get() = CommonMainStrings0._10

public actual val SharedRes.strings.abcd_hebrew: StringResource
  get() = CommonMainStrings0.abcd_hebrew

public actual val SharedRes.strings.about: StringResource
  get() = CommonMainStrings0.about

public actual val SharedRes.strings.action_reorder: StringResource
  get() = CommonMainStrings0.action_reorder

public actual val SharedRes.strings.ad_free_for_minutes_action: StringResource
  get() = CommonMainStrings0.ad_free_for_minutes_action

public actual val SharedRes.strings.ad_label: StringResource
  get() = CommonMainStrings0.ad_label

public actual val SharedRes.strings.ad_not_available: StringResource
  get() = CommonMainStrings0.ad_not_available

public actual val SharedRes.strings.ad_place: StringResource
  get() = CommonMainStrings0.ad_place

public actual val SharedRes.strings.add_bookmark: StringResource
  get() = CommonMainStrings0.add_bookmark

public actual val SharedRes.strings.add_nikud: StringResource
  get() = CommonMainStrings0.add_nikud

public actual val SharedRes.strings.add_open_question: StringResource
  get() = CommonMainStrings0.add_open_question

public actual val SharedRes.strings.add_question: StringResource
  get() = CommonMainStrings0.add_question

public actual val SharedRes.strings.add_questions_from_sheet: StringResource
  get() = CommonMainStrings0.add_questions_from_sheet

public actual val SharedRes.strings.ads_already_disabled_format: StringResource
  get() = CommonMainStrings0.ads_already_disabled_format

public actual val SharedRes.strings.advanced_options: StringResource
  get() = CommonMainStrings0.advanced_options

public actual val SharedRes.strings.all_the_bible: StringResource
  get() = CommonMainStrings0.all_the_bible

public actual val SharedRes.strings.alphabetical: StringResource
  get() = CommonMainStrings0.alphabetical

public actual val SharedRes.strings.and_lasted: StringResource
  get() = CommonMainStrings0.and_lasted

public actual val SharedRes.strings.announcement: StringResource
  get() = CommonMainStrings0.announcement

public actual val SharedRes.strings.answer: StringResource
  get() = CommonMainStrings0.answer

public actual val SharedRes.strings.answers_list: StringResource
  get() = CommonMainStrings0.answers_list

public actual val SharedRes.strings.app_name: StringResource
  get() = CommonMainStrings0.app_name

public actual val SharedRes.strings.app_name_debug: StringResource
  get() = CommonMainStrings0.app_name_debug

public actual val SharedRes.strings.app_up_to_date: StringResource
  get() = CommonMainStrings0.app_up_to_date

public actual val SharedRes.strings.app_up_to_date_version_format: StringResource
  get() = CommonMainStrings0.app_up_to_date_version_format

public actual val SharedRes.strings.apply_mikud: StringResource
  get() = CommonMainStrings0.apply_mikud

public actual val SharedRes.strings.at_least_one_book: StringResource
  get() = CommonMainStrings0.at_least_one_book

public actual val SharedRes.strings.available_in_full_version: StringResource
  get() = CommonMainStrings0.available_in_full_version

public actual val SharedRes.strings.back: StringResource
  get() = CommonMainStrings0.back

public actual val SharedRes.strings.background: StringResource
  get() = CommonMainStrings0.background

public actual val SharedRes.strings.bible: StringResource
  get() = CommonMainStrings0.bible

public actual val SharedRes.strings.bible_contest_for: StringResource
  get() = CommonMainStrings0.bible_contest_for

public actual val SharedRes.strings.bible_recordings: StringResource
  get() = CommonMainStrings0.bible_recordings

public actual val SharedRes.strings.book_name: StringResource
  get() = CommonMainStrings0.book_name

public actual val SharedRes.strings.bookmark_added: StringResource
  get() = CommonMainStrings0.bookmark_added

public actual val SharedRes.strings.bookmark_not_added_yet: StringResource
  get() = CommonMainStrings0.bookmark_not_added_yet

public actual val SharedRes.strings.books: StringResource
  get() = CommonMainStrings0.books

public actual val SharedRes.strings.books_and_chapters: StringResource
  get() = CommonMainStrings0.books_and_chapters

public actual val SharedRes.strings.browse: StringResource
  get() = CommonMainStrings0.browse

public actual val SharedRes.strings.browse_and_complete_chapter: StringResource
  get() = CommonMainStrings0.browse_and_complete_chapter

public actual val SharedRes.strings.browse_bible: StringResource
  get() = CommonMainStrings0.browse_bible

public actual val SharedRes.strings.browse_chumash: StringResource
  get() = CommonMainStrings0.browse_chumash

public actual val SharedRes.strings.browse_place: StringResource
  get() = CommonMainStrings0.browse_place

public actual val SharedRes.strings.by_user_choice: StringResource
  get() = CommonMainStrings0.by_user_choice

public actual val SharedRes.strings.cancel: StringResource
  get() = CommonMainStrings0.cancel

public actual val SharedRes.strings.cannot_open_link: StringResource
  get() = CommonMainStrings0.cannot_open_link

public actual val SharedRes.strings.chapter_complete_reset: StringResource
  get() = CommonMainStrings0.chapter_complete_reset

public actual val SharedRes.strings.chapter_content_title: StringResource
  get() = CommonMainStrings0.chapter_content_title

public actual val SharedRes.strings.chapter_copy: StringResource
  get() = CommonMainStrings0.chapter_copy
